import { Product } from '../shared/types/Product';

export const mockProducts: Product[] = [
    {
        id: 1,
        title: 'Смарт-часы X100',
        price: 7490,
        category: 'Гаджеты',
        image: 'https://yandex-images.clstorage.net/9Iv6aM431/b1361aowae/wAPc6fEztgkeG8Vs1mWl8tZ_u2ESUpcxDAEGx8oskZcvPecy-q6-IVRyiuDyMtjzHl9KP6zG2l_yuNhj8LsczoZXzqW2dq1cQ17aON5moPDLIvhwDgiTbBZDWsmJL8nJfT2IWYjWzB0vRfeV2kWS8RVYSXKx0cs2la30MbHFXo_5OuXe6TTMHBsYv1j1Y6P95TePbAAQm34IInHXs1XhjB9cv26G7_cqKk_dh8dbhMgZbH5HzsjbHrvI6wKMx16U7zD_ztYa4igPIb92wEqg-vY-tEIKGY9aDj1P1Z9e4qwIX79QuPvsFgJy0IXlQ5r-D39uetrE6S-b3-A_je1Nk_kq-_z7C_EnFDyIXeFgm_r7O49-AQu7bAMKTfewbcqdGlyEV7347xMHUcm-60OA9A1GRkTQ2_gimMf4Naz9WZbvK_zn1Rf9ISAwunPASKrCwhKyRgMOjH0KDW33r1LLlidEo2ib_MwFJ2LHvMNSnt4hbXh_3c3fCo_31yq-2Wy9_hvP5uQS0RMrJbF5x0C07egwvXAzFZNCPC16_Kt_978pa7VTgv37NxZa_6fiSbj4PHNubtPwygiNyvo6lM9zptok_tvoJ9odMCyNYsZHkvrpPZRQCAqufQgLeNG8RsiYOWKzbaLvyCkYYceg1Hi_yT5RSV_05NwEkMv4Ea_iebD8EMzk9jDeJQsvjnDAaLf-3zi0ST4Wj0MBM179lFXLsCVXkX-k0cYlJGDViOdqodUWWklszPLsJoXC7Ae99ker2BXk6vEy8wwvCph32ESV0c8hmWgwBbBgDjNC7LJD8ZclTJJjivDNGidC0ZrRRq74PU5hYPn5yRGg28o6l-Rgq8A1_sDgJsICKzC_Tf9Cou7kA6J3BBGRQhUubOmUbuqkKHq9Sp3g7w4Mb8u-3Vih-hpyVX7W6f0hrcDPB4L5aLDzI-rpyi_cAB4BhF78X5HH6x2fbQEPqUUzK0nqtVo',
        description: 'Водонепроницаемые, GPS, 7-дневный аккумулятор',
    },
    {
        id: 2,
        title: 'Беспроводные наушники Air Beat',
        price: 5990,
        category: 'Аудио',
        image: 'https://avatars.mds.yandex.net/i?id=3a517755edf78ce2fc3f8d4863f528170da1bff3-9220156-images-thumbs&n=13',
        description: 'Шумоподавление, 30 часов работы, удобная посадка',
    },
    {
        id: 3,
        title: 'Портативная колонка Boom Mini',
        price: 4290,
        category: 'Аудио',
        image: 'https://avatars.mds.yandex.net/i?id=7405cf5fd8afa96bca1db149bd2c9c021679d2d6-12522553-images-thumbs&n=13',
        description: 'Компактная Bluetooth-колонка с насыщенным звуком',
    },
    {
        id: 4,
        title: 'Электросамокат Urban Ride',
        price: 28990,
        category: 'Транспорт',
        image: 'https://avatars.mds.yandex.net/i?id=a3d79af0119e5c01d8a2a95157af0001f50ff3c7-8184004-images-thumbs&n=13',
        description: 'До 25 км на одном заряде, складная конструкция',
    },
    {
        id: 5,
        title: 'Ноутбук ProBook 14',
        price: 64990,
        category: 'Компьютеры',
        image: 'https://avatars.mds.yandex.net/i?id=cabe2e08f1521ebe204d5a7c6435abb69656edc6-10715741-images-thumbs&n=13',
        description: '14 дюймов, SSD 512 ГБ, 16 ГБ RAM, тонкий корпус',
    },
    {
        id: 6,
        title: 'Клавиатура Mech TKL',
        price: 6990,
        category: 'Компьютеры',
        image: 'https://avatars.mds.yandex.net/i?id=135ca34f0cc3f2501721dbe035b00a59f9ff252e-9066167-images-thumbs&n=13',
        description: 'Механическая клавиатура без цифрового блока с RGB-подсветкой',
    },
    {
        id: 7,
        title: 'Фитнес-браслет Pulse Fit',
        price: 3490,
        category: 'Гаджеты',
        image: 'https://avatars.mds.yandex.net/i?id=8653e8c4d88c6d819bcd058f0ede628c2f73f8e3-5876837-images-thumbs&n=13',
        description: 'Пульс, шагомер, мониторинг сна и уведомления',
    },
    {
        id: 8,
        title: 'Монитор Vision 27',
        price: 18490,
        category: 'Компьютеры',
        image: 'https://avatars.mds.yandex.net/i?id=f0140e84fe4f485655510428dd1a80762d48b3bd-5371416-images-thumbs&n=13',
        description: '27 дюймов, IPS, 2K-разрешение, тонкие рамки',
    },
    {
        id: 9,
        title: 'Робот-пылесос CleanMaster',
        price: 15990,
        category: 'Дом',
        image: 'https://yandex-images.clstorage.net/52Xiv1H48/536d21bdZ_p/0Bg_1tdn8KWaiJ0B-nzUqc1Y_A9ptR981GiAOPu3DEAmsByB5DeGIRNLByaD70XQ4jv7EaDNNVlLPC5gXWdK-ZFdrMYHoaYyyo5OEvu-la4fn64PeHIL_hGuQPv_4M6BJ-XTGizrGm-ZB03vCWQWkOHvL1annaTCBe1xd40oXqyc03HfEPL25d8T0gC1dhyrG5p8D_GxSTTYd0qz8vfOHrY6HV8naJOhVw1CY48jHdvipOvaulsjRoh3u7fGr9ymFNi00dP4dW1SGBoFuT4Qq54QcUY29IA21HqKsrGzhpw3-p9b7GAeah4OQi1L4pyVruznFT5Zr48Hv_s_A6PR7NEUttcbdzMnEhGbizVw2W1V3XWCOrSOtVj1ifN_sAVd-L2S0-hn321SRgNgySacWGtnpdLwVKXHTDiy9oyjnS8VXzqZkvlzZ1yWXk8z8J1rH9OzB7o8iX_T9oE9PXxOVXn01RcmL1cq2c-MbYIqnRNvpKOaOFqth4d-cnOC7J2mk1V825W8sm8VXlMBf_ddatzfdck7cgk_WPXB_Xg7zJAxe51RJO7T5JYBhydNoxvapueq2f1aqkmO-f5xCyqcohLd9laZPD7oG5pQTX-zkWrWFfvCuHkF_Ve0RrzzswTbMzudkCbuEOqWyoxojuQb26soL9B5WmsAyHW-sQnvUqmY2bRYlnF-YRSbU4t4M1HrmJP_THg_wDRWcky-M3QJ1XJyH9jqJtaqUwiDKMYtmt7pbahSPdcszss7f_lIJV_slRc7EVJ2sekQG5pD8Llfr5heuMI2dI4ymDTFev74i5b29J5QZ2iaatfLCycO7tnTq2Mu2jedKs1Be3_3giIRJdQQt17WuLooEp-YiPT3nCGTWfUOevnLON-7wvs18wdWubxXHiIqU2mSAIyizWNcXSBsKxb81yLPT7t-v0BgVeiT1bIfGDw16BASWoC4-5du3pp5gTh9zHJT_wl7ew',
        description: 'Лазерная навигация, влажная уборка, управление с телефона',
    },
    {
        id: 10,
        title: 'Игровая мышь Spectrum Pro',
        price: 3990,
        category: 'Компьютеры',
        image: 'https://avatars.mds.yandex.net/i?id=50d4ee75d5d8241d45cd840e4c04982b-5910950-images-thumbs&n=13',
        description: '16000 DPI, 8 программируемых кнопок, RGB-подсветка',
    },
    {
        id: 11,
        title: 'Умная лампочка LED Color',
        price: 1290,
        category: 'Дом',
        image: 'https://avatars.mds.yandex.net/i?id=96c54dfe4a400d53e272ac3dd7976ae59dc19df2-4011861-images-thumbs&n=13',
        description: '16 млн цветов, управление через Wi-Fi, совместимость с Алисой',
    },
    {
        id: 12,
        title: 'Внешний аккумулятор PowerCore 20000',
        price: 3490,
        category: 'Гаджеты',
        image: 'https://avatars.mds.yandex.net/i?id=99dfbbc1e54cd5547675ddfacf036ff230c595b5-7575569-images-thumbs&n=13',
        description: '20000 мАч, быстрая зарядка, два USB-порта',
    },
    {
        id: 13,
        title: 'Геймпад Wireless Fighter',
        price: 4990,
        category: 'Игры',
        image: 'https://avatars.mds.yandex.net/i?id=3b3a2155d9e94d734085c2bcdfc417f499a0ac72-5617472-images-thumbs&n=13',
        description: 'Беспроводной геймпад с виброотдачей и турбо-режимом',
    },
    {
        id: 14,
        title: 'Электрическая зубная щётка SonicCare',
        price: 7990,
        category: 'Здоровье',
        image: 'https://yandex-images.clstorage.net/52Xiv1H48/536d21bdZ_p/0Bg_1tdn8KWaiJ0B-nzUqc1Y_A9ptR981GiW7O9gDYJlpJ2UsHcGNUaKhjLWLpBFIvgvEOFMYc1K_HuhCGYeuBCI7MQHoiXxCA6IA_q9lC6aCDhIfzQIOkT_g_ytNZpCJ37THazr3SueQY5siKnQkyNvaAMwnG5CGjd5MEanX2DeE3LRFTFypdaSWk0yNJEqn9o4wbx2wvOd9cvxujUF0_iwlhYvYhPllE4C6s-im5Boq-Qe9hvqz4D9uXvBJVXo1dZ8Eh-y-ijdWl9BejiRrxXXcQb5v8D_kDXKsv59h1I4MpLdJ-_YrJdOTC4OI9XcIKcrmvSXI0BIvTG-zSgfLRnUetqQ9LBo1NvRzTTxV2TY07UKubFDcx82i3z9_kadfz8a2SAu3-DfDwGsyiMYGavl7FT5nWsLz_T4Mc1k3OlSWDRTHrTwJlMeFcu0tVEu1hUwijG2ifgcPkU-MbVOHDZ43hdopphrVoAM58YiUx1o46Sc95UrwIk0fT-CZFVvWB52VFt1-G-bE1uHs3VQ7drT_gt_NslzH36Fe3Y3i1S5MJgVqSJWJJiLRihPpJrUK-rnWfeS5ckOuH-2RGVR7tCU-1jb-X9hXxAXh_e5UOcQXfWIdDoLfF75xPD-_8BW-TBZF6nhWCRTgAnrCKSb2eRv7t33U6yPgvi_tIGrWmTU1vVXlrn2bl4T0YB3edGplll7SDL_wn2Y88YwOfLOF7CyEdthJxjhkY9Jo8Elnpuh6GyZehRijMw59_VLph9pGlm8k5F2fmre2hkI_XeVqVse9QZ5scSz3noC_bVwjZM2M5lWL2vYZVIHRmsCZpPZr27kkzASYQaMOfk_TOjWKB3V8xdffb9oWtjSDLO0G6JcUzlK9PTO9FF9gza-_E3cfvrXE22i2yCZgMOoj-MdUqBrKFh6GmMITDix_Q6sG2_Y0LLZ2_J_atca2kC_v1Tvn9-2CHDzhHgVtgN4fY',
        description: 'Звуковая технология, 5 режимов, зарядная станция',
    },
    {
        id: 15,
        title: 'Смарт-розетка Smart Plug',
        price: 990,
        category: 'Дом',
        image: 'https://avatars.mds.yandex.net/i?id=70938547ab8125eb0566c708dbe6ac0ab05bd9fb-5604449-images-thumbs&n=13',
        description: 'Дистанционное управление, таймер, мониторинг энергии',
    },
    {
        id: 16,
        title: 'Фотоаппарат Mirrorless Z50',
        price: 54990,
        category: 'Фототехника',
        image: 'https://yandex-images.clstorage.net/52Xiv1H48/536d21bdZ_p/0Bg_1tdn8KWaiJ0B-nzUqc1Y_A9ptR981GiU-Hr2zINlpAlAJDUToBNekjDDbgaEN3u6BDVZdFkcKK1gSPIf-VDcLMcHImXwy00IA_q9lC6aCDhIfzQIOkT_g_ytNZpCJ37THazr3SueQY5siKnQkyNvaAMwnG5CGjd5MEanX2DeE3LRFTFypdaSWk0yNJEqn9o4wbx2wvOd9cvxujUF0_iwlhYvYhPllE4C6s-im5Boq-Qe9hvqz4D9uXvBJVXo1dZ8Eh-y-ijdWl9BejiRrxXXcQb5v8D_kDXKsv59h1I4MpLdJ-_YrJdOTC4OI9XcIKcrmvSXI0BIvTG-zSgfLRnUetqQ9LBo1NvRzTTxV2TY07UKubFDcx82i3z9_kadfz8a2SAu3-DfDwGsyiMYGavl7FT5nWsLz_T4Mc1k3OlSWDRTHrTwJlMeFcu0tVEu1hUwijG2ifgcPkU-MbVOHDZ43hdopphrVoAM58YiUx1o46Sc95UrwIk0fT-CZFVvWB52VFt1-G-bE1uHs3VQ7drT_gt_NslzH36Fe3Y3i1S5MJgVqSJWJJiLRihPpJrUK-rnWfeS5ckOuH-2RGVR7tCU-1jb-X9hXxAXh_e5UOcQXfWIdDoLfF75xPD-_8BW-TBZF6nhWCRTgAnrCKSb2eRv7t33U6yPgvi_tIGrWmTU1vVXlrn2bl4T0YB3edGplll7SDL_wn2Y88YwOfLOF7CyEdthJxjhkY9Jo8Elnpuh6GyZehRijMw59_VLph9pGlm8k5F2fmre2hkI_XeVqVse9QZ5scSz3noC_bVwjZM2M5lWL2vYZVIHRmsCZpPZr27kkzASYQaMOfk_TOjWKB3V8xdffb9oWtjSDLO0G6JcUzlK9PTO9FF9gza-_E3cfvrXE22i2yCZgMOoj-MdUqBrKFh6GmMITDix_Q6sG2_Y0LLZ2_J_atca2kC_v1Tvn9-2CHDzhHgVtgN4fY',
        description: '20.9 МП, 4K-видео, сменная оптика',
    },
    {
        id: 17,
        title: 'Беспроводная зарядка MagStand',
        price: 2490,
        category: 'Гаджеты',
        image: 'https://avatars.mds.yandex.net/i?id=e76793bc27f68f9e89542cc421d600a2d0d4b7dc4d71e80b-12658662-images-thumbs&n=13',
        description: '15 Вт, подставка для телефона, совместима с MagSafe',
    },
    {
        id: 18,
        title: 'Наушники-вкладыши Evo Buds',
        price: 3990,
        category: 'Аудио',
        image: 'https://yandex-images.clstorage.net/52Xiv1H48/536d21bdZ_p/0Bg_1tdn8KWaiJ0B-nzUqc1Y_A9ptR981GiA7DrjjBYz5AhA5bbG9IZfxvMVeZBFdu94BKAZtZuffS00SabfeISIrMYHIeexSk-O0vu-la4fn64PeHIL_hGuQPv_4M6BJ-XTGizrGm-ZB03vCWQWkOHvL1annaTCBe1xd40oXqyc03HfEPL25d8T0gC1dhyrG5p8D_GxSTTYd0qz8vfOHrY6HV8naJOhVw1CY48jHdvipOvaulsjRoh3u7fGr9ymFNi00dP4dW1SGBoFuT4Qq54QcUY29IA21HqKsrGzhpw3-p9b7GAeah4OQi1L4pyVruznFT5Zr48Hv_s_A6PR7NEUttcbdzMnEhGbizVw2W1V3XWCOrSOtVj1ifN_sAVd-L2S0-hn321SRgNgySacWGtnpdLwVKXHTDiy9oyjnS8VXzqZkvlzZ1yWXk8z8J1rH9OzB7o8iX_T9oE9PXxOVXn01RcmL1cq2c-MbYIqnRNvpKOaOFqth4d-cnOC7J2mk1V825W8sm8VXlMBf_ddatzfdck7cgk_WPXB_Xg7zJAxe51RJO7T5JYBhydNoxvapueq2f1aqkmO-f5xCyqcohLd9laZPD7oG5pQTX-zkWrWFfvCuHkF_Ve0RrzzswTbMzudkCbuEOqWyoxojuQb26soL9B5WmsAyHW-sQnvUqmY2bRYlnF-YRSbU4t4M1HrmJP_THg_wDRWcky-M3QJ1XJyH9jqJtaqUwiDKMYtmt7pbahSPdcszss7f_lIJV_slRc7EVJ2sekQG5pD8Llfr5heuMI2dI4ymDTFev74i5b29J5QZ2iaatfLCycO7tnTq2Mu2jedKs1Be3_3giIRJdQQt17WuLooEp-YiPT3nCGTWfUOevnLON-7wvs18wdWubxXHiIqU2mSAIyizWNcXSBsKxb81yLPT7t-v0BgVeiT1bIfGDw16BASWoC4-5du3pp5gTh9zHJT_wl7ew',
        description: 'Гибридное шумоподавление, влагозащита IPX5',
    },
    {
        id: 19,
        title: 'Автомобильный видеорегистратор RoadSafe',
        price: 5990,
        category: 'Автотовары',
        image: 'https://yandex-images.clstorage.net/52Xiv1H48/536d21bdZ_p/0Bg_1tdn8KWaiJ0B-nzUqc1Y_A9ptR981GiVLS_jDJYnccmVMLcTdVPf0eZWusSEI-77RqGYYNvfaC-1XWbf-hCI7MdFoGcwCs_IA_q9lC6aCDhIfzQIOkT_g_ytNZpCJ37THazr3SueQY5siKnQkyNvaAMwnG5CGjd5MEanX2DeE3LRFTFypdaSWk0yNJEqn9o4wbx2wvOd9cvxujUF0_iwlhYvYhPllE4C6s-im5Boq-Qe9hvqz4D9uXvBJVXo1dZ8Eh-y-ijdWl9BejiRrxXXcQb5v8D_kDXKsv59h1I4MpLdJ-_YrJdOTC4OI9XcIKcrmvSXI0BIvTG-zSgfLRnUetqQ9LBo1NvRzTTxV2TY07UKubFDcx82i3z9_kadfz8a2SAu3-DfDwGsyiMYGavl7FT5nWsLz_T4Mc1k3OlSWDRTHrTwJlMeFcu0tVEu1hUwijG2ifgcPkU-MbVOHDZ43hdopphrVoAM58YiUx1o46Sc95UrwIk0fT-CZFVvWB52VFt1-G-bE1uHs3VQ7drT_gt_NslzH36Fe3Y3i1S5MJgVqSJWJJiLRihPpJrUK-rnWfeS5ckOuH-2RGVR7tCU-1jb-X9hXxAXh_e5UOcQXfWIdDoLfF75xPD-_8BW-TBZF6nhWCRTgAnrCKSb2eRv7t33U6yPgvi_tIGrWmTU1vVXlrn2bl4T0YB3edGplll7SDL_wn2Y88YwOfLOF7CyEdthJxjhkY9Jo8Elnpuh6GyZehRijMw59_VLph9pGlm8k5F2fmre2hkI_XeVqVse9QZ5scSz3noC_bVwjZM2M5lWL2vYZVIHRmsCZpPZr27kkzASYQaMOfk_TOjWKB3V8xdffb9oWtjSDLO0G6JcUzlK9PTO9FF9gza-_E3cfvrXE22i2yCZgMOoj-MdUqBrKFh6GmMITDix_Q6sG2_Y0LLZ2_J_atca2kC_v1Tvn9-2CHDzhHgVtgN4fY',
        description: '1440p, ночное видение, датчик удара, GPS',
    },
    {
        id: 20,
        title: 'Электронная книга PocketBook Lux',
        price: 11990,
        category: 'Книги',
        image: 'https://avatars.mds.yandex.net/i?id=cba5f698ce0de029cd7e3512eb21eb07944eb91f-4438863-images-thumbs&n=13',
        description: '6 дюймов, подсветка, 16 ГБ памяти, водозащита',
    },
    {
        id: 21,
        title: 'Спортивные часы Active Pro',
        price: 8990,
        category: 'Гаджеты',
        image: 'https://yandex-images.clstorage.net/52Xiv1H48/536d21bdZ_p/0Bg_1tdn8KWaiJ0B-nzUqc1Y_A9ptR981GiVubtiWVfm5F3DsTaTtNKLByfXbsRRIzo6RGGNIVlfafs1XLNKOlFcbMcGoeYwC89IA_q9lC6aCDhIfzQIOkT8V-zvOcLeO_mTHigpGyoZTYflQi7WwybrYd9kEyPIRDx7uUboEu8W2D7TG30y6BWSX4T4_JBkGNr3B3L9Q_eUvMh9MPeH1bhwXdAiJpesXkbM5gnqWt7gbOVS_tnjg8O-cTFNLRwsHFu2XhC1N-Rdnl8BcvHZo10T9Qt_PUK00PRK_PB1gx6w_ZaZISbZaJ_HgqpB5pVa4uAs3TaZa0bPszv0gS8a5JMd_B4ZNLloE1eZyr_1Ha8dHXaH8D4DetN3izO3eAsatzyR1WlnlOpbx09vyqRSlO_qZJax0KLJz__4MMqjVG0dXbxQnvF9bpMTn4CxM5gvlRq8DPM2zTgfPIOy_j_P1P-01l7g6JmhV8YEawmiGlzh4iRd9xAnx4D_cbbA5RZqWJy0GVb8MyKU055DvfVWrtua_Ifwdg19WL5G-nF3idY-MBgRLuPTbt5AzaJKq1mZ4eXqVHCcJU5G_nU3SG-bZtgQMxeS_38i0B-eSXd7XS3Qlj6IsfFM9tB2Dfgxd0jUPvMWEeXonK2ZQMyvhS5QHeEkoxL83OVMgzB-vUwtlWmVULoYk_y5JVDfHwfxf9PtllP3iXf7TjYXewO5ePUAGPY1VtQn59zlUMHJ7cCp0llsY20Rsh2tDUk9O7CCotytkp8yHBM1ca3a0VsHPDhdo90d8Ucxcor7m_lAPf50iJW4eZZQ5G_TLZOCxK_OL1pTJmVum_Ido8dOc_LxhS6TKVyU8x6XN7qplBLVDDt1ke9QWPsAvnULMJB1gHK2vcbQ-rCVFS_oVu4eB0okwSqWmGxtbJUyHOsFDDc_tkAr0ufYGzMcGvWy5ZgZmkH4-R6t1F-xjPq-i35TMsA6to',
        description: 'GPS, компас, барометр, 20 режимов тренировок',
    },
    {
        id: 22,
        title: 'МФУ лазерное LaserPrint 2200',
        price: 12490,
        category: 'Компьютеры',
        image: 'https://yandex-images.clstorage.net/52Xiv1H48/536d21bdZ_p/0Bg_1tdn8KWaiJ0B-nzUqc1Y_A9ptR981GiALHri2EMyMZwBcHZT9RPeUvDD-gTQdzsukPVNYBkKvPshiPAfecZd7McG4WfxSs0IA_q9lC6aCDhIfzQIOkT_g_ytNZpCJ37THazr3SueQY5siKnQkyNvaAMwnG5CGjd5MEanX2DeE3LRFTFypdaSWk0yNJEqn9o4wbx2wvOd9cvxujUF0_iwlhYvYhPllE4C6s-im5Boq-Qe9hvqz4D9uXvBJVXo1dZ8Eh-y-ijdWl9BejiRrxXXcQb5v8D_kDXKsv59h1I4MpLdJ-_YrJdOTC4OI9XcIKcrmvSXI0BIvTG-zSgfLRnUetqQ9LBo1NvRzTTxV2TY07UKubFDcx82i3z9_kadfz8a2SAu3-DfDwGsyiMYGavl7FT5nWsLz_T4Mc1k3OlSWDRTHrTwJlMeFcu0tVEu1hUwijG2ifgcPkU-MbVOHDZ43hdopphrVoAM58YiUx1o46Sc95UrwIk0fT-CZFVvWB52VFt1-G-bE1uHs3VQ7drT_gt_NslzH36Fe3Y3i1S5MJgVqSJWJJiLRihPpJrUK-rnWfeS5ckOuH-2RGVR7tCU-1jb-X9hXxAXh_e5UOcQXfWIdDoLfF75xPD-_8BW-TBZF6nhWCRTgAnrCKSb2eRv7t33U6yPgvi_tIGrWmTU1vVXlrn2bl4T0YB3edGplll7SDL_wn2Y88YwOfLOF7CyEdthJxjhkY9Jo8Elnpuh6GyZehRijMw59_VLph9pGlm8k5F2fmre2hkI_XeVqVse9QZ5scSz3noC_bVwjZM2M5lWL2vYZVIHRmsCZpPZr27kkzASYQaMOfk_TOjWKB3V8xdffb9oWtjSDLO0G6JcUzlK9PTO9FF9gza-_E3cfvrXE22i2yCZgMOoj-MdUqBrKFh6GmMITDix_Q6sG2_Y0LLZ2_J_atca2kC_v1Tvn9-2CHDzhHgVtgN4fY',
        description: 'Печать, сканирование, копирование, Wi-Fi, автоподатчик',
    },
    {
        id: 23,
        title: 'Фитнес-коврик Premium Non-Slip',
        price: 2490,
        category: 'Спорт',
        image: 'https://yandex-images.clstorage.net/52Xiv1H48/536d21bdZ_p/0Bg_1tdn8KWaiJ0B-nzUqc1Y_A9ptR981GiVLS83GwJm5ErU8KJTthNex-eWr0URN7u7BKFNIMxK6a0jiTALuYVdbMcH4idxyE5IA_q9lC6aCDhIfzQIOkT_g_ytNZpCJ37THazr3SueQY5siKnQkyNvaAMwnG5CGjd5MEanX2DeE3LRFTFypdaSWk0yNJEqn9o4wbx2wvOd9cvxujUF0_iwlhYvYhPllE4C6s-im5Boq-Qe9hvqz4D9uXvBJVXo1dZ8Eh-y-ijdWl9BejiRrxXXcQb5v8D_kDXKsv59h1I4MpLdJ-_YrJdOTC4OI9XcIKcrmvSXI0BIvTG-zSgfLRnUetqQ9LBo1NvRzTTxV2TY07UKubFDcx82i3z9_kadfz8a2SAu3-DfDwGsyiMYGavl7FT5nWsLz_T4Mc1k3OlSWDRTHrTwJlMeFcu0tVEu1hUwijG2ifgcPkU-MbVOHDZ43hdopphrVoAM58YiUx1o46Sc95UrwIk0fT-CZFVvWB52VFt1-G-bE1uHs3VQ7drT_gt_NslzH36Fe3Y3i1S5MJgVqSJWJJiLRihPpJrUK-rnWfeS5ckOuH-2RGVR7tCU-1jb-X9hXxAXh_e5UOcQXfWIdDoLfF75xPD-_8BW-TBZF6nhWCRTgAnrCKSb2eRv7t33U6yPgvi_tIGrWmTU1vVXlrn2bl4T0YB3edGplll7SDL_wn2Y88YwOfLOF7CyEdthJxjhkY9Jo8Elnpuh6GyZehRijMw59_VLph9pGlm8k5F2fmre2hkI_XeVqVse9QZ5scSz3noC_bVwjZM2M5lWL2vYZVIHRmsCZpPZr27kkzASYQaMOfk_TOjWKB3V8xdffb9oWtjSDLO0G6JcUzlK9PTO9FF9gza-_E3cfvrXE22i2yCZgMOoj-MdUqBrKFh6GmMITDix_Q6sG2_Y0LLZ2_J_atca2kC_v1Tvn9-2CHDzhHgVtgN4fY',
        description: '10 мм толщина, нескользящее покрытие, экологичный материал',
    },
    {
        id: 24,
        title: 'Термопот HotFlow 4L',
        price: 5490,
        category: 'Дом',
        image: 'https://avatars.mds.yandex.net/i?id=e4b3e1b4a6937559cde871a44b5a03f7b37eb247-5626878-images-thumbs&n=13',
        description: 'Нагревает и поддерживает температуру, диспенсер',
    },
    {
        id: 25,
        title: 'Мини-проектор Pocket Cinema',
        price: 13990,
        category: 'Электроника',
        image: 'https://avatars.mds.yandex.net/i?id=ebf1efb240303c376f8fe30fd3b44cc055b2f392-7736363-images-thumbs&n=13',
        description: '1080p, встроенный аккумулятор, портативный',
    },
    {
        id: 26,
        title: 'Смарт-кольцо Ring Health',
        price: 7990,
        category: 'Гаджеты',
        image: 'https://avatars.mds.yandex.net/i?id=2079c5d216af6229edf8b17746deb5854bcaa5df-3597607-images-thumbs&n=13',
        description: 'Отслеживание сна, пульсоксиметр, водонепроницаемое',
    },
    {
        id: 27,
        title: 'Гироскутер Balance Master',
        price: 11990,
        category: 'Транспорт',
        image: 'https://avatars.mds.yandex.net/i?id=b7a99549e043b7ffa32fe78114bf101d9edb7ede-12884907-images-thumbs&n=13',
        description: '6.5 дюймов, Bluetooth-колонка, до 15 км/ч',
    },
    {
        id: 28,
        title: 'Ортопедическая подушка DreamCloud',
        price: 3990,
        category: 'Здоровье',
        image: 'https://yandex-images.clstorage.net/52Xiv1H48/536d21bdZ_p/0Bg_1tdn8KWaiJ0B-nzUqc1Y_A9ptR981GiWrq4jTUIy8EkBJHeH4dKeEeaCehAENvp7hSHYNdjfq2-g3SYJ-RDLbMeGYSZxyA9IA_q9lC6aCDhIfzQIOkT_g_ytNZpCJ37THazr3SueQY5siKnQkyNvaAMwnG5CGjd5MEanX2DeE3LRFTFypdaSWk0yNJEqn9o4wbx2wvOd9cvxujUF0_iwlhYvYhPllE4C6s-im5Boq-Qe9hvqz4D9uXvBJVXo1dZ8Eh-y-ijdWl9BejiRrxXXcQb5v8D_kDXKsv59h1I4MpLdJ-_YrJdOTC4OI9XcIKcrmvSXI0BIvTG-zSgfLRnUetqQ9LBo1NvRzTTxV2TY07UKubFDcx82i3z9_kadfz8a2SAu3-DfDwGsyiMYGavl7FT5nWsLz_T4Mc1k3OlSWDRTHrTwJlMeFcu0tVEu1hUwijG2ifgcPkU-MbVOHDZ43hdopphrVoAM58YiUx1o46Sc95UrwIk0fT-CZFVvWB52VFt1-G-bE1uHs3VQ7drT_gt_NslzH36Fe3Y3i1S5MJgVqSJWJJiLRihPpJrUK-rnWfeS5ckOuH-2RGVR7tCU-1jb-X9hXxAXh_e5UOcQXfWIdDoLfF75xPD-_8BW-TBZF6nhWCRTgAnrCKSb2eRv7t33U6yPgvi_tIGrWmTU1vVXlrn2bl4T0YB3edGplll7SDL_wn2Y88YwOfLOF7CyEdthJxjhkY9Jo8Elnpuh6GyZehRijMw59_VLph9pGlm8k5F2fmre2hkI_XeVqVse9QZ5scSz3noC_bVwjZM2M5lWL2vYZVIHRmsCZpPZr27kkzASYQaMOfk_TOjWKB3V8xdffb9oWtjSDLO0G6JcUzlK9PTO9FF9gza-_E3cfvrXE22i2yCZgMOoj-MdUqBrKFh6GmMITDix_Q6sG2_Y0LLZ2_J_atca2kC_v1Tvn9-2CHDzhHgVtgN4fY',
        description: 'Пена с эффектом памяти, анатомическая форма',
    },
    {
        id: 29,
        title: 'Ультразвуковой увлажнитель Mist Air',
        price: 2990,
        category: 'Дом',
        image: 'https://avatars.mds.yandex.net/i?id=bddf9badcdfd1b0113db6b9e0c76e5596dce25f5-7011831-images-thumbs&n=13',
        description: '4 литра, аромакапсула, бесшумный режим',
    },
    {
        id: 30,
        title: 'Карта памяти ProSpeed 128GB',
        price: 1990,
        category: 'Компьютеры',
        image: 'https://avatars.mds.yandex.net/i?id=f227d7b4591793f9a211d033a800e71219078fb5-11497947-images-thumbs&n=13',
        description: 'Class 10, U3, для видео 4K',
    },

];
